import axios from "axios";

const GetPayRollEmpByBatchId = (batchId) => {
  return axios.get("PayRollBatch/GetPayRollEmpBybatchId", {
    params: {
      p_batchId: batchId,
    },
  });
};

const AddPayRollEmp = (payload) => {
  return axios.post(
    "PayRollBatch/AddPayRollEmp",
    null,
    {
      params: {
        p_amount: payload.amount,
        p_createdBy: payload.createdBy,
        p_isActive: payload.isActive,
        p_batchId: payload.batchId,
        p_employeeId: payload.employeeId,
        p_percentage: payload.percentage,
        p_isIncluded: payload.isIncluded,
        p_isProcessed: payload.isProcessed,
        p_overrideReason: payload.overrideReason,
        p_remarks: payload.remarks,
      },
    }
  );
};

const UpdatePayRollEmp = (payload) => {
  return axios.post(
    "PayRollBatch/UpdatePayRollEmp",
    null,
    {
      params: {
        p_batchEmployeeId: payload.batchEmployeeId,
        p_isActive: payload.isActive,
        p_amount: payload.amount,
        p_percentage: payload.percentage,
        p_overrideReason: payload.overrideReason || "",
        p_remarks: payload.remarks || "",
      },
    }
  );
};

export default {
    GetPayRollEmpByBatchId,
    AddPayRollEmp,
    UpdatePayRollEmp,
};